import { jsx as _jsx } from "react/jsx-runtime";
/** True when the user asked the OS for less motion: no ripple then (the state layer still shows the press). */
export const prefersReducedMotion = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
/**
 * Material ripple: a wave from the pointer, drawn by `.jui-ripple::after` inside the control.
 * Restarted on every press by toggling `data-on`; React never renders that attribute, so it is not overwritten.
 */
export function startRipple(event) {
    if (event.button > 0 || prefersReducedMotion())
        return;
    const element = event.currentTarget;
    const layer = element.querySelector(":scope > .jui-ripple");
    if (!layer)
        return;
    const rect = element.getBoundingClientRect();
    const x = event.clientX - rect.left, y = event.clientY - rect.top;
    const radius = Math.hypot(Math.max(x, rect.width - x), Math.max(y, rect.height - y));
    layer.style.setProperty("--jui-ripple-x", `${Math.round(x)}px`);
    layer.style.setProperty("--jui-ripple-y", `${Math.round(y)}px`);
    layer.style.setProperty("--jui-ripple-d", `${Math.ceil(radius * 2)}px`);
    layer.removeAttribute("data-on");
    void layer.offsetWidth; // restart the animation
    layer.setAttribute("data-on", "true");
}
/** The ripple's clip box; place it as a direct child of the control. */
export const Ripple = () => _jsx("span", { className: "jui-ripple", "aria-hidden": "true" });
